import { FormattedDate } from "react-intl";

interface Props {
  date: Date;
  timezone: string;
}

export function ZonedTime({ date, timezone }: Readonly<Props>) {
  return (
    <FormattedDate
      value={date}
      timeZone={timezone}
      year="numeric"
      weekday="short"
      month="short"
      timeZoneName="shortGeneric"
    />
  );
}
